import { Component, effect, EventEmitter, input, model, Output, signal } from '@angular/core';
import { OrderformIframeService } from '../../services/orderform-iframe.service';

@Component({
  selector: 'orderform-iframe-modal',
  templateUrl: './iframe-modal.component.html',
  styleUrls: ['./iframe-modal.component.scss'],
})
export class IframeModalComponent {
  // Input signals
  label = input<string>('');
  url = input<string>('');
  downloadURL = input<string | undefined>();
  modalVisible = model<boolean>(false);

  // Internal writable signals for openModal method
  private _internalLabel = signal<string>('');
  private _internalUrl = signal<string>('');
  private _internalDownloadURL = signal<string | undefined>(undefined);

  @Output() public readonly close = new EventEmitter<void>();

  public usedInIframe = this.orderformIframeService.iframeActive;
  public scrollPosition$ = this.orderformIframeService.scrollPosition$;

  constructor(private orderformIframeService: OrderformIframeService) {
    // Watch modalVisible changes to emit close event
    effect(() => {
      const visible = this.modalVisible();
      if (!visible) {
        this.close.emit();
      }
    });
  }

  /**
   * @param label
   * @param url
   */
  openModal(label: string, url: string) {
    this.orderformIframeService.ds24_sendScrollPosition();
    this._internalLabel.set(label);
    this._internalUrl.set(url);
    this.modalVisible.set(true);

    if (['/terms', '/privacy', '/cancellation'].find((key) => url.includes(key))) {
      let downloadURL = url.replace(`page/popup`, `download`);
      downloadURL = downloadURL.replace(`download/legal`, `download/reseller`);
      this._internalDownloadURL.set(downloadURL);
    } else {
      this._internalDownloadURL.set(undefined);
    }
  }

  closeModal() {
    this.modalVisible.set(false);
  }

  download() {
    const downloadUrl = this.downloadURL() || this._internalDownloadURL();
    if (downloadUrl) {
      window.open(downloadUrl, '_blank');
    }
  }

  // Computed getters for template
  get displayLabel(): string {
    return this.label() || this._internalLabel();
  }

  get displayUrl(): string {
    return this.url() || this._internalUrl();
  }

  get displayDownloadURL(): string | undefined {
    return this.downloadURL() || this._internalDownloadURL();
  }
}
